export enum AppMenus {
  DASHBOARD = "DASHBOARD",
  SETTINGS = "CONFIGURACION",
  CONTROL_PANEL = "CONTROL_PANEL",
  HELPIA_PEOPLE = "HELPIA_PEOPLE",
  PANEL_EMPRESA = "PANEL_EMPRESA",
  COMERCIAL = "COMERCIAL",
  HISTORICO = "HISTORICO",
  GENERAL_REPORTS = "GENERAL_REPORTS",
  REPORTS = "REPORTS",
  ACCESO_SOPORTE = "ACCESO_SOPORTE",

  USERS = "USERS",
  BLOG = "BLOG",
  ROLES = "ROLES",
  NEWS_SUBSCRIBERS = "NEWS_SUBSCRIBERS",
  PLANS = "PLANS",
  COMPANIES = "COMPANIES",
  QUOTER = "QUOTER",
  HELP = "HELP",
  FAQS = "FAQS",
  CHANNELS = "CHANNELS",
  PLANS_COMPANIES = "PLANS_COMPANIES",
  TICKETS = "TICKETS",
  WEB_ACCESS_LOGS = "WEB_ACCESS_LOGS",
  CCENTER = "CCENTER",
  STARTING = "STARTING",
  SUPPORTS_TEMPLATE = "SUPPORTS_TEMPLATE",
  DIGITAL_SIGNATURE = "DIGITAL_SIGNATURE",
  LOGS = "LOGS",
  REVIEWS = "REVIEWS",
  CONNECTION_USER = "CONNECTION_USER",
  CONFIGURATION = "CONFIGURATION",

  //Helpia people
  HELPIA_PEOPLE_AGENT = "HELPIA_PEOPLE_AGENT",
  HELPIA_PEOPLE_PROJECT = "HELPIA_PEOPLE_PROJECT",
  HELPIA_PEOPLE_BRAND = "HELPIA_PEOPLE_BRAND",
  HELPIA_PEOPLE_REPORTS = "HELPIA_PEOPLE_REPORTS",

  // Reports
  RESUMEN_ENCUESTA = "RESUMEN_ENCUESTA",
}

export enum AppModules {
  DASHBOARD = "DASHBOARD",

  //List from Backend
  USERS = "USERS",
  CONTROL_PANEL = "CONTROL_PANEL",
  BLOG = "BLOG",
  ROLES = "ROLES",
  NEWS_SUBSCRIBERS = "NEWS_SUBSCRIBERS",
  SETTINGS = "SETTINGS",
  PLANS = "PLANS",
  COMPANIES = "COMPANIES",
  REPORTS = "REPORTS",
  QUOTER = "QUOTER",
  HELP = "HELP",
  FAQS = "FAQS",
  CHANNELS = "CHANNELS",
  PLANS_COMPANIES = "PLANS_COMPANIES",
  TICKETS = "TICKETS",
  WEB_ACCESS_LOGS = "WEB_ACCESS_LOGS",
  CCENTER = "CCENTER",
  STARTING = "STARTING",
  SUPPORTS_TEMPLATE = "SUPPORTS_TEMPLATE",
  DIGITAL_SIGNATURE = "DIGITAL_SIGNATURE",
  LOGS = "LOGS",
  REVIEWS = "REVIEWS",
  CLAIMS = "CLAIMS",
  INVOICING = 'INVOICING',
  INVOICES = 'INVOICES',

  ACCESO_SOPORTE = "ACCESO_SOPORTE",
  HELPIA_PEOPLE = "HELPIA_PEOPLE",
  PANEL_EMPRESA = "PANEL_EMPRESA",
  COMERCIAL = "COMERCIAL",
  HISTORICO = "HISTORICO",
  CONNECTION_USER = "CONNECTION_USER",
  CONFIGURATION = "CONFIGURATION",

  //Helpia people
  HELPIA_PEOPLE_AGENT = "HELPIA_PEOPLE_AGENT",
  HELPIA_PEOPLE_PROJECT = "HELPIA_PEOPLE_PROJECT",
  HELPIA_PEOPLE_BRAND = "HELPIA_PEOPLE_BRAND",
  HELPIA_PEOPLE_REPORTS = "HELPIA_PEOPLE_REPORTS",

  // Reports
  RESUMEN_ENCUESTA = "RESUMEN_ENCUESTA",
  GENERAL_REPORTS = "GENERAL_REPORTS",
  DYNAMIC_REPORT = "DYNAMIC_REPORT",
}

export enum ModuleAction {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  TO_LIST = "TO_LIST",
  DETAILS = "DETAILS",
  CREATE_AND_UPDATE = "CREATE_AND_UPDATE",
  DISABLE = "DISABLE",
  ENABLE = "ENABLE",

  //Helpia-People
  SITUATION = "SITUATION",
  SEE_BRANDS = "SEE_BRANDS",
  IMPORT = "IMPORT",
  EXPORT = "EXPORT",
  SEE_TRAZAS = "SEE_TRAZAS",
  SEE_STATE = "SEE_STATE",
  EDIT_HOURS = "EDIT_HOURS",
  SEE_EDIT_HOURS = "SEE_EDIT_HOURS",
  SEE_AGENTS = "SEE_AGENTS",
  EDIT_HOURS_AFTER_CLOSE_REGISTER = "EDIT_HOURS_AFTER_CLOSE_REGISTER",

  //User
  USERS_CHANGE_PASSWORD = "USERS_CHANGE_PASSWORD",

  //Reports
  REPORT_TOTAL_TICKETS = "REPORT_TOTAL_TICKETS",
  REPORT_TICKETS_BY_TYPES = "REPORT_TICKETS_BY_TYPES",
  REPORT_TICKETS_BY_CHANNELS = "REPORT_TICKETS_BY_CHANNELS",
  REPORT_TICKETS_BY_MONTHS_WEEKS = "REPORT_TICKETS_BY_MONTHS_WEEKS",
  REPORT_TICKETS_BY_DAYS_HOURS = "REPORT_TICKETS_BY_DAYS_HOURS",

  //Companies
  COMPANY_CHANNELS = "COMPANY_CHANNELS",
  COMPANY_TICKETS_LIST = "COMPANY_TICKETS_LIST",
  COMPANY_TICKET_DETAILS = "COMPANY_TICKET_DETAILS",
  COMPANY_TICKET_UPDATE = "COMPANY_TICKET_UPDATE",
  COMPANY_SUPPORTS = "COMPANY_SUPPORTS",
  COMPANY_SUPPORT_UPDATE = "COMPANY_SUPPORT_UPDATE",
  COMPANY_SUPPORT_EXPORT = "COMPANY_SUPPORT_EXPORT",

  //logs
  LOGS_SUPPORT = "LOGS_SUPPORT",
  LOGS_SUPPORT_TEMPLATE = "LOGS_SUPPORT_TEMPLATE",
  LOGS_PLANS = "LOGS_PLANS",
  LOGS_SETTINGS = "LOGS_SETTINGS",

  //Menus
  ALL = "ALL",

  // GENERAL_REPORTS
  RESUMEN_ENCUESTA = "RESUMEN_ENCUESTA",
  DYNAMIC_REPORT = "DYNAMIC_REPORT",
  GENERAL_REPORTS = "GENERAL_REPORTS",
}

export interface ModuleInfo {
  label: string;
  path: string;
  module: AppModules;
  availableActions: ModuleAction[];
}
